export default "__VITE_ASSET__BhwalZCw__"